<template>
  <div>
    <vue-headful title="Matches" />
    <Header page_title="Matches" />
    <div class="px-4 mx-2">
      <div class="container-fluid px-0 pb-1 mb-2">
        <div class="px-4 mx-2" hidden>
          <div id="filter-results" class="mb-2 pb-2">
            <div class="important-style" data-toggle="collapse" data-target="#collapseForm" aria-expanded="false" aria-controls="collapseForm">
              <div class="bar d-block position-relative">
                <i class="material-icons">error_outline</i>Match kansen vergroten?
                <i class="material-icons arrow right">keyboard_arrow_right</i>
                <i class="material-icons arrow down">keyboard_arrow_down</i>
              </div>
            </div>
            <div class="collapse" id="collapseForm">
              <form>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Vergroot je zoekgebied"/>
                  <i class="material-icons">location_searching</i>
                </div>
                <div class="form-group">
                  <input type="text" class="form-control" placeholder="Pas je beschikbaarheid aan"/>
                  <i class="material-icons-outlined">calendar_today</i>
                </div>
              </form>
            </div>
          </div>
        </div>
        <p class="mt-3">
          <job-filter @filter-change="filterChanged" :showAll="false" :subbranch="true" />
        </p>
        <div v-if="results ? results.data && results.data.length > 0 :false" class="mb-4">
          <p class="margin-bottom-2">
            <strong v-if="results.meta.total == 1">{{ results.meta.total }} match gevonden</strong>
            <strong v-else>{{ results.meta.total }} matches gevonden</strong>
          </p>
          <JobCard
            v-for="job in results.data"
            :key="job.job_id"
            :job="job"
            :job_ids="job_ids"
            :match="true"
          />
          <Pagination :results="results" :api="api" @page-change="pageChanged"/>
        </div>
        <Empty v-else text="Je hebt geen matchende vacatures." />
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";
import JobFilter from "@/components/JobFilter.vue";

export default {
  data: function() {
    return {
      api: "jobs/matches",
      results: null,
      originalResults: null,
      job_ids: null,
      filterValues: {
        showAll: false,
        maxShown: 20,
        subbranch: ''
      },
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      this.results = await this.getListwithPages(this.api);

      if (this.results.data.length > 1) {
        this.job_ids = this.results.data.map(({ job_id }) => job_id);
      }

      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    },
    async filterChanged(data) {
      this.filterValues = data;
      this.$store.state.loading = true;

      if(this.filterValues.subbranch === '1')
        this.api = 'jobs/matches?subbranch=1';
      else if(this.filterValues.subbranch === '2')
        this.api = 'jobs/matches?subbranch=2';
      else
        this.api = 'jobs/matches';

      this.results = await this.getListwithPages(this.api);
      this.$store.state.loading = false;
    }
  },
  components: {
    JobCard,
    JobFilter
  }
};
</script>

<style scoped>

.margin-top-2 {
  margin-top: 2rem;
}

.margin-bottom-2 {
  margin-bottom: 2rem;
}

</style>